import { useContext } from 'react';

import '../init';
import { windowIsAvailable } from '../utils';
import { ConfigurationContext } from '../components/Configuration/Configuration';

/**
 * @example const configuration = useConfiguration();
 * @returns configuration:: The configuration context object including all of the properties that can be set on the Configuration component.
 */
const useConfiguration = () => {
  const context = windowIsAvailable
    ? window.cosmos.configurationContext ?? ConfigurationContext
    : ConfigurationContext;

  return useContext(context);
};

export default useConfiguration;
